export const convertTimeToUTC = (time: string | Date): Date => {
  if (!time) return null;
  let utcTime: Date;
  if (typeof time === 'string') {
    utcTime = new Date(time);
  } else {
    utcTime = new Date(time.toISOString());
  }
  const offset = utcTime.getTimezoneOffset();
  utcTime = new Date(utcTime.getTime() - offset * 60000);
  return utcTime;
}

export const revertUTCToLocalTime = (utcTime: string | Date): Date => {
  if (!utcTime) return null;
  let localTime: Date;
  if (typeof utcTime === 'string') {
    localTime = new Date(utcTime);
  } else {
    localTime = new Date(utcTime.toISOString());
  }
  const offset = localTime.getTimezoneOffset();
  localTime = new Date(localTime.getTime() + offset * 60000);
  return localTime;
}
